export const TIPO_FACTURA = {
  FACTURA_RECIBIDA: 1,
  FACTURA_EMITIDA: 2,
} as const

export type TipoFacturaType = (typeof TIPO_FACTURA)[keyof typeof TIPO_FACTURA]
